import bridge from './core';
import './apis/openNewPage';
import './apis/setTitle';
import './apis/report';
import './apis/setAuthorization';
import './apis/hideBackButton';
import './apis/share';
import './apis/getAuthorization';
import './apis/setRightButtonVisible';
import './apis/setShareButtonVisible';
import './apis/receiveApp';
import './apis/toLogin';
import './apis/saveImage';
import './apis/springfesgoods';
import './apis/cardsShare';

export default bridge;
